import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { avancarRelogioDaSimulacao, continuarAvancoDoRelogio } from '../store/actions';
import { selectAvancoDoRelogio, selectSimulacaoAtual } from '../store/selectors';
import type { UnidadeDeAvanco } from '../types';
import { ehUnidadeDeAvanco, validarAvanco } from '../utils/avancoDoRelogio';

/**
 * Controle "Avançar tempo do teste" (CA-15). Quantidade e unidade são rascunho da tela; o relógio
 * mostrado é sempre o `relogioVirtualEm` que o core devolveu.
 */
export function useAvancoDoRelogio() {
  const $ = _c(24);
  const dispatch = useAppDispatch();
  const simulacao = useAppSelector(selectSimulacaoAtual);
  const {
    avancando,
    pendentes,
    erro
  } = useAppSelector(selectAvancoDoRelogio);
  const [quantidade, setQuantidade] = useState("1");
  const [unidade, setUnidade] = useState("DIAS");
  const ativa = simulacao?.status === "ATIVA";
  let t0;
  if ($[0] !== quantidade || $[1] !== unidade) {
    t0 = validarAvanco(quantidade, unidade);
    $[0] = quantidade;
    $[1] = unidade;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const validacao = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = valor => {
      if (ehUnidadeDeAvanco(valor)) {
        setUnidade(valor);
      }
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const alterarUnidade = t1;
  let t2;
  if ($[4] !== ativa || $[5] !== dispatch || $[6] !== validacao.avanco || $[7] !== validacao.valido) {
    t2 = () => {
      if (!ativa || !validacao.valido) {
        return;
      }
      dispatch(avancarRelogioDaSimulacao(validacao.avanco));
    };
    $[4] = ativa;
    $[5] = dispatch;
    $[6] = validacao.avanco;
    $[7] = validacao.valido;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const avancar = t2;
  let t3;
  if ($[9] !== dispatch) {
    t3 = () => {
      dispatch(continuarAvancoDoRelogio());
    };
    $[9] = dispatch;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const continuar = t3;
  const t4 = simulacao !== null;
  const t5 = simulacao?.relogioVirtualEm ?? null;
  const t6 = validacao.valido ? null : validacao.mensagem;
  const t7 = ativa && validacao.valido && !avancando;
  let t8;
  if ($[11] !== ativa || $[12] !== avancando || $[13] !== avancar || $[14] !== continuar || $[15] !== erro || $[16] !== pendentes || $[17] !== quantidade || $[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t7 || $[22] !== unidade) {
    t8 = {
      quantidade,
      unidade,
      alterarQuantidade: setQuantidade,
      alterarUnidade,
      started: t4,
      ativa,
      relogioVirtualEm: t5,
      mensagemDeValidacao: t6,
      podeAvancar: t7,
      avancando,
      pendentes,
      erro,
      avancar,
      continuar
    };
    $[11] = ativa;
    $[12] = avancando;
    $[13] = avancar;
    $[14] = continuar;
    $[15] = erro;
    $[16] = pendentes;
    $[17] = quantidade;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = unidade;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
}